// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
 * FUTURISTIC THEME - SIMPLIFIED IMPLEMENTATION
 * Focused on stability and consistency with light mode
 */

/* Base theme variables */
.futuristic-theme {
  --primary-color: #00ffea;
  --secondary-color: #ff00ff;
  --accent-color: #fffc00;
  --text-color: #ffffff;
  --background-dark: #050518;
  --card-bg: rgba(5, 5, 20, 0.9);
  --text-shadow: 0 0 5px var(--primary-color);
  --border-glow: 0 0 8px var(--primary-color);
  
  /* Set basic styles for entire theme */
  color: var(--text-color);
  background-color: var(--background-dark) !important;
}

/* CRITICAL: Ensure starfield background shows through */
body.futuristic-theme,
html.futuristic-theme,
#root.futuristic-theme {
  background-color: var(--background-dark) !important;
  color: var(--text-color) !important;
}

/* 
 * FIXED ELEMENTS - Header & Footer
 * Keep exact same behavior as light mode but with dark styling
 */

/* Header - Fixed at top */
.futuristic-theme .MuiAppBar-root {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  z-index: 1100 !important;
  background-color: rgba(5, 5, 20, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  box-shadow: 0 0 15px rgba(0, 255, 240, 0.5);
  border-bottom: 1px solid rgba(0, 255, 240, 0.3);
}

/* Footer - Fixed at bottom */
.futuristic-theme .MuiBox-root[component="footer"] {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  width: 100% !important;
  z-index: 1000 !important;
  background-color: rgba(5, 5, 20, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  box-shadow: 0 0 15px rgba(0, 255, 240, 0.5);
  border-top: 1px solid rgba(0, 255, 240, 0.3);
}

/* Content area - Adjust for fixed header/footer */
.futuristic-theme main {
  padding-top: 64px !important; /* Match header height */
  padding-bottom: 64px !important; /* Match footer height */
  min-height: calc(100vh - 128px) !important; /* Full height minus header/footer */
  background-color: transparent !important; /* Let starfield show through */
}

/* Card styling */
.futuristic-theme .MuiPaper-root {
  background-color: var(--card-bg) !important;
  border: 1px solid rgba(0, 255, 240, 0.3) !important;
  box-shadow: 0 0 15px rgba(0, 255, 240, 0.2) !important;
}

/* Text styling */
.futuristic-theme .MuiTypography-root {
  color: var(--text-color) !important;
}

/* Button styling */
.futuristic-theme .MuiButton-contained:not(.MuiButton-containedPrimary):not(.MuiButton-containedSecondary) {
  background: linear-gradient(45deg, #4c00ff, #00a3ff) !important;
  color: white !important;
  box-shadow: 0 0 10px rgba(0, 163, 255, 0.5) !important;
}

/* Input styling */
.futuristic-theme .MuiInputBase-root {
  background-color: rgba(10, 10, 30, 0.7) !important;
  color: var(--text-color) !important;
  border: 1px solid rgba(0, 255, 240, 0.3) !important;
}

.futuristic-theme .MuiInputLabel-root {
  color: var(--primary-color) !important;
}

/* Make sure links are visible */
.futuristic-theme a {
  color: var(--primary-color) !important;
  text-shadow: var(--text-shadow) !important;
}

/* Poll cards specific styling */
.futuristic-theme .poll-card {
  background-color: var(--card-bg) !important;
  border: 1px solid rgba(0, 255, 240, 0.3) !important;
  box-shadow: 0 0 15px rgba(0, 255, 240, 0.2) !important;
}

/* Ensure all dialogs have proper styling */
.futuristic-theme .MuiDialog-paper {
  background-color: var(--card-bg) !important;
  border: 1px solid rgba(0, 255, 240, 0.3) !important;
  box-shadow: 0 0 15px rgba(0, 255, 240, 0.5) !important;
}

/* Ensure all list items have proper styling */
.futuristic-theme .MuiListItem-root {
  border-bottom: 1px solid rgba(0, 255, 240, 0.1) !important;
}

/* Ensure all icons have proper styling */
.futuristic-theme .MuiSvgIcon-root {
  color: var(--primary-color) !important;
  filter: drop-shadow(0 0 3px rgba(0, 255, 240, 0.5)) !important;
}

/* Cards & Containers - Neon styling */
.futuristic-theme .MuiCard-root {
  background-color: var(--card-bg);
  border: 1px solid rgba(0, 255, 240, 0.3);
  box-shadow: 0 0 10px rgba(0, 255, 240, 0.2);
}

/* Typography - Futuristic styling */
.futuristic-theme .MuiTypography-h1,
.futuristic-theme .MuiTypography-h2,
.futuristic-theme .MuiTypography-h3,
.futuristic-theme .MuiTypography-h4,
.futuristic-theme .MuiTypography-h5,
.futuristic-theme .MuiTypography-h6 {
  text-shadow: var(--text-shadow);
  letter-spacing: 1px;
}

/* Buttons - Neon styling */
.futuristic-theme .MuiButton-root {
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s ease;
}

.futuristic-theme .MuiButton-contained {
  background: linear-gradient(45deg, #0a0a2a 30%, #1a1a4a 90%);
  border: 1px solid var(--primary-color);
  box-shadow: var(--border-glow);
}

.futuristic-theme .MuiButton-contained:hover {
  background: linear-gradient(45deg, #1a1a4a 30%, #2a2a6a 90%);
  transform: scale(1.05);
  box-shadow: 0 0 15px var(--primary-color);
}

/* Custom App Title */
.futuristic-theme .MuiToolbar-root .MuiTypography-h6 {
  display: flex;
  align-items: center;
  text-shadow: 0 0 10px var(--primary-color);
}

/* Links and Interactive Elements */
.futuristic-theme a:hover {
  color: var(--accent-color);
  text-shadow: 0 0 8px var(--accent-color);
}

/* Special elements - Music Player, Free MPC Button */
.futuristic-theme .music-player-container {
  display: block !important; /* Only show in futuristic theme */
}

.futuristic-theme .get-free-mpc-button {
  display: flex !important; /* Only show in futuristic theme */
}

/* Theme Switch styling */
.futuristic-theme .theme-switch {
  box-shadow: 0 0 10px var(--primary-color);
}

/* 
 * FORM ELEMENTS 
 */
.futuristic-theme .MuiTextField-root,
.futuristic-theme .MuiSelect-root,
.futuristic-theme .MuiInput-root {
  border-radius: 4px;
  background-color: rgba(5, 5, 20, 0.7);
  border: 1px solid var(--primary-color);
  color: var(--text-color);
}

/* Ensure non-styled elements still get theme colors */
.futuristic-theme input,
.futuristic-theme select,
.futuristic-theme textarea {
  background-color: rgba(5, 5, 20, 0.7);
  color: var(--text-color);
  border: 1px solid var(--primary-color);
}

/* 
 * ANIMATION KEYFRAMES
 * Simple and performant animations
 */
@keyframes glow {
  0% { box-shadow: 0 0 5px var(--primary-color); }
  50% { box-shadow: 0 0 15px var(--primary-color); }
  100% { box-shadow: 0 0 5px var(--primary-color); }
}

@keyframes pulse {
  0% { opacity: 0.7; }
  50% { opacity: 1; }
  100% { opacity: 0.7; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/futuristic-theme.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,yBAAyB;AACzB;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;EAC1B,8BAA8B;EAC9B,2CAA2C;EAC3C,2CAA2C;;EAE3C,sCAAsC;EACtC,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA,wDAAwD;AACxD;;;EAGE,mDAAmD;EACnD,mCAAmC;AACrC;;AAEA;;;EAGE;;AAEF,0BAA0B;AAC1B;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,gDAAgD;EAChD,sCAAsC;EACtC,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA,6BAA6B;AAC7B;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,gDAAgD;EAChD,sCAAsC;EACtC,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA,kDAAkD;AAClD;EACE,4BAA4B,EAAE,wBAAwB;EACtD,+BAA+B,EAAE,wBAAwB;EACzD,0CAA0C,EAAE,oCAAoC;EAChF,wCAAwC,EAAE,+BAA+B;AAC3E;;AAEA,iBAAiB;AACjB;EACE,2CAA2C;EAC3C,mDAAmD;EACnD,sDAAsD;AACxD;;AAEA,iBAAiB;AACjB;EACE,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;EACE,+DAA+D;EAC/D,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA,kBAAkB;AAClB;EACE,kDAAkD;EAClD,mCAAmC;EACnC,mDAAmD;AACrD;;AAEA;EACE,sCAAsC;AACxC;;AAEA,gCAAgC;AAChC;EACE,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA,gCAAgC;AAChC;EACE,2CAA2C;EAC3C,mDAAmD;EACnD,sDAAsD;AACxD;;AAEA,2CAA2C;AAC3C;EACE,2CAA2C;EAC3C,mDAAmD;EACnD,sDAAsD;AACxD;;AAEA,8CAA8C;AAC9C;EACE,0DAA0D;AAC5D;;AAEA,yCAAyC;AACzC;EACE,sCAAsC;EACtC,8DAA8D;AAChE;;AAEA,sCAAsC;AACtC;EACE,gCAAgC;EAChC,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA,oCAAoC;AACpC;;;;;;EAME,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,4DAA4D;EAC5D,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,qDAAqD;AACrD;EACE,yBAAyB,EAAE,kCAAkC;AAC/D;;AAEA;EACE,wBAAwB,EAAE,kCAAkC;AAC9D;;AAEA,yBAAyB;AACzB;EACE,yCAAyC;AAC3C;;AAEA;;EAEE;AACF;;;EAGE,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA,sDAAsD;AACtD;;;EAGE,qCAAqC;EACrC,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;;;EAGE;AACF;EACE,KAAK,wCAAwC,EAAE;EAC/C,MAAM,yCAAyC,EAAE;EACjD,OAAO,wCAAwC,EAAE;AACnD;;AAEA;EACE,KAAK,YAAY,EAAE;EACnB,MAAM,UAAU,EAAE;EAClB,OAAO,YAAY,EAAE;AACvB","sourcesContent":["/* \n * FUTURISTIC THEME - SIMPLIFIED IMPLEMENTATION\n * Focused on stability and consistency with light mode\n */\n\n/* Base theme variables */\n.futuristic-theme {\n  --primary-color: #00ffea;\n  --secondary-color: #ff00ff;\n  --accent-color: #fffc00;\n  --text-color: #ffffff;\n  --background-dark: #050518;\n  --card-bg: rgba(5, 5, 20, 0.9);\n  --text-shadow: 0 0 5px var(--primary-color);\n  --border-glow: 0 0 8px var(--primary-color);\n  \n  /* Set basic styles for entire theme */\n  color: var(--text-color);\n  background-color: var(--background-dark) !important;\n}\n\n/* CRITICAL: Ensure starfield background shows through */\nbody.futuristic-theme,\nhtml.futuristic-theme,\n#root.futuristic-theme {\n  background-color: var(--background-dark) !important;\n  color: var(--text-color) !important;\n}\n\n/* \n * FIXED ELEMENTS - Header & Footer\n * Keep exact same behavior as light mode but with dark styling\n */\n\n/* Header - Fixed at top */\n.futuristic-theme .MuiAppBar-root {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  z-index: 1100 !important;\n  background-color: rgba(5, 5, 20, 0.8) !important;\n  backdrop-filter: blur(10px) !important;\n  box-shadow: 0 0 15px rgba(0, 255, 240, 0.5);\n  border-bottom: 1px solid rgba(0, 255, 240, 0.3);\n}\n\n/* Footer - Fixed at bottom */\n.futuristic-theme .MuiBox-root[component=\"footer\"] {\n  position: fixed !important;\n  bottom: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  z-index: 1000 !important;\n  background-color: rgba(5, 5, 20, 0.8) !important;\n  backdrop-filter: blur(10px) !important;\n  box-shadow: 0 0 15px rgba(0, 255, 240, 0.5);\n  border-top: 1px solid rgba(0, 255, 240, 0.3);\n}\n\n/* Content area - Adjust for fixed header/footer */\n.futuristic-theme main {\n  padding-top: 64px !important; /* Match header height */\n  padding-bottom: 64px !important; /* Match footer height */\n  min-height: calc(100vh - 128px) !important; /* Full height minus header/footer */\n  background-color: transparent !important; /* Let starfield show through */\n}\n\n/* Card styling */\n.futuristic-theme .MuiPaper-root {\n  background-color: var(--card-bg) !important;\n  border: 1px solid rgba(0, 255, 240, 0.3) !important;\n  box-shadow: 0 0 15px rgba(0, 255, 240, 0.2) !important;\n}\n\n/* Text styling */\n.futuristic-theme .MuiTypography-root {\n  color: var(--text-color) !important;\n}\n\n/* Button styling */\n.futuristic-theme .MuiButton-contained:not(.MuiButton-containedPrimary):not(.MuiButton-containedSecondary) {\n  background: linear-gradient(45deg, #4c00ff, #00a3ff) !important;\n  color: white !important;\n  box-shadow: 0 0 10px rgba(0, 163, 255, 0.5) !important;\n}\n\n/* Input styling */\n.futuristic-theme .MuiInputBase-root {\n  background-color: rgba(10, 10, 30, 0.7) !important;\n  color: var(--text-color) !important;\n  border: 1px solid rgba(0, 255, 240, 0.3) !important;\n}\n\n.futuristic-theme .MuiInputLabel-root {\n  color: var(--primary-color) !important;\n}\n\n/* Make sure links are visible */\n.futuristic-theme a {\n  color: var(--primary-color) !important;\n  text-shadow: var(--text-shadow) !important;\n}\n\n/* Poll cards specific styling */\n.futuristic-theme .poll-card {\n  background-color: var(--card-bg) !important;\n  border: 1px solid rgba(0, 255, 240, 0.3) !important;\n  box-shadow: 0 0 15px rgba(0, 255, 240, 0.2) !important;\n}\n\n/* Ensure all dialogs have proper styling */\n.futuristic-theme .MuiDialog-paper {\n  background-color: var(--card-bg) !important;\n  border: 1px solid rgba(0, 255, 240, 0.3) !important;\n  box-shadow: 0 0 15px rgba(0, 255, 240, 0.5) !important;\n}\n\n/* Ensure all list items have proper styling */\n.futuristic-theme .MuiListItem-root {\n  border-bottom: 1px solid rgba(0, 255, 240, 0.1) !important;\n}\n\n/* Ensure all icons have proper styling */\n.futuristic-theme .MuiSvgIcon-root {\n  color: var(--primary-color) !important;\n  filter: drop-shadow(0 0 3px rgba(0, 255, 240, 0.5)) !important;\n}\n\n/* Cards & Containers - Neon styling */\n.futuristic-theme .MuiCard-root {\n  background-color: var(--card-bg);\n  border: 1px solid rgba(0, 255, 240, 0.3);\n  box-shadow: 0 0 10px rgba(0, 255, 240, 0.2);\n}\n\n/* Typography - Futuristic styling */\n.futuristic-theme .MuiTypography-h1,\n.futuristic-theme .MuiTypography-h2,\n.futuristic-theme .MuiTypography-h3,\n.futuristic-theme .MuiTypography-h4,\n.futuristic-theme .MuiTypography-h5,\n.futuristic-theme .MuiTypography-h6 {\n  text-shadow: var(--text-shadow);\n  letter-spacing: 1px;\n}\n\n/* Buttons - Neon styling */\n.futuristic-theme .MuiButton-root {\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  transition: all 0.3s ease;\n}\n\n.futuristic-theme .MuiButton-contained {\n  background: linear-gradient(45deg, #0a0a2a 30%, #1a1a4a 90%);\n  border: 1px solid var(--primary-color);\n  box-shadow: var(--border-glow);\n}\n\n.futuristic-theme .MuiButton-contained:hover {\n  background: linear-gradient(45deg, #1a1a4a 30%, #2a2a6a 90%);\n  transform: scale(1.05);\n  box-shadow: 0 0 15px var(--primary-color);\n}\n\n/* Custom App Title */\n.futuristic-theme .MuiToolbar-root .MuiTypography-h6 {\n  display: flex;\n  align-items: center;\n  text-shadow: 0 0 10px var(--primary-color);\n}\n\n/* Links and Interactive Elements */\n.futuristic-theme a:hover {\n  color: var(--accent-color);\n  text-shadow: 0 0 8px var(--accent-color);\n}\n\n/* Special elements - Music Player, Free MPC Button */\n.futuristic-theme .music-player-container {\n  display: block !important; /* Only show in futuristic theme */\n}\n\n.futuristic-theme .get-free-mpc-button {\n  display: flex !important; /* Only show in futuristic theme */\n}\n\n/* Theme Switch styling */\n.futuristic-theme .theme-switch {\n  box-shadow: 0 0 10px var(--primary-color);\n}\n\n/* \n * FORM ELEMENTS \n */\n.futuristic-theme .MuiTextField-root,\n.futuristic-theme .MuiSelect-root,\n.futuristic-theme .MuiInput-root {\n  border-radius: 4px;\n  background-color: rgba(5, 5, 20, 0.7);\n  border: 1px solid var(--primary-color);\n  color: var(--text-color);\n}\n\n/* Ensure non-styled elements still get theme colors */\n.futuristic-theme input,\n.futuristic-theme select,\n.futuristic-theme textarea {\n  background-color: rgba(5, 5, 20, 0.7);\n  color: var(--text-color);\n  border: 1px solid var(--primary-color);\n}\n\n/* \n * ANIMATION KEYFRAMES\n * Simple and performant animations\n */\n@keyframes glow {\n  0% { box-shadow: 0 0 5px var(--primary-color); }\n  50% { box-shadow: 0 0 15px var(--primary-color); }\n  100% { box-shadow: 0 0 5px var(--primary-color); }\n}\n\n@keyframes pulse {\n  0% { opacity: 0.7; }\n  50% { opacity: 1; }\n  100% { opacity: 0.7; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
